import { ExportSection } from '../types';

// A subset with loaded columns but none selected is skipped on save, so it groups nothing.
export const hasExportableSubsetSections = (
  sections: ExportSection[]
): boolean =>
  sections.some(
    (section) =>
      section.kind === 'subset' &&
      section.enabled &&
      (section.columns.length === 0 ||
        section.columns.some((column) => column.selected))
  );
